var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BlockEditorTestResult',_vm._g(_vm._b({attrs:{"showTestResultModal":_vm.isShowTestResultModal},on:{"update:showTestResultModal":function($event){_vm.isShowTestResultModal=$event},"update:show-test-result-modal":function($event){_vm.isShowTestResultModal=$event}}},'BlockEditorTestResult',_vm.props,false),_vm.listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }